<template>
  <div>
    <div style="display: flex; flex-direction: column; position: relative">
      <div
        id="container"
        style="min-height: 100vh; display: contents"
      >
        <div
          id="anchor"
          style="position: fixed; top: calc(50% - 150px); left: calc(50% - 150px); width: 300px; height: 300px"
        />

        <div
          v-show="showDrawer"
          id="sidebar"
          data-cy="sidebar"
        >
          <div class="logoHolder">
            <img
              style="margin-top: 9px; margin-left: 9px;"
              src="../assets/logo.svg"
            >
            <span class="logoUnderText">pallställsbyggare</span>
          </div>

          <div
            v-if="!showTour"
            class="mobileNotOptimal"
          >
            <p>Använder du en vanlig dator så får du pallstället uppritat grafiskt!</p>
          </div>
          <div
            id="sideBarWidth"
            style="z-index: 2000; min-width: 100%;"
          >
            <div style="width: 300px; margin: 0 -1em; z-index: -1; position: fixed; top: 0; left: 0;" />
            <!-- <div class="is-hidden-tablet" style="height: 1em"></div> -->
            <!-- id: select-upright, tog bort class is-mobile-->
            <b-field
              id="select-upright"
              label="Gavlar"
              class="textControll"
            >
              <b-dropdown
                v-model="selectedUprights"
                :mobile-modal="false"
                style="width: 100%"
              >
                <button
                  slot="trigger"
                  class="button"
                  type="button"
                  style="width: 100%; justify-content: space-between"
                >
                  <template v-if="!selectedUprights">
                    <span
                      class="textControll"
                      style="opacity: 0.5"
                    >Välj bärkapacitet...
                    </span>
                  </template>
                  <template v-else>
                    <span class="textControll">{{ selectedUprights.name }} ton</span>
                  </template>
                  <b-icon
                    type="is-primary"
                    icon="caret-down"
                  />
                </button>

                <b-dropdown-item
                  v-for="upright in availableUprights"
                  :key="upright.name"
                  :value="upright"
                >
                  <div class="media">
                    <div class="media-content">
                      <p class="textControll">
                        {{ upright.name }} ton
                      </p>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
            <!-- id: select-height, tog bort class is-mobile-->
            <b-field
              id="select-height"
              label="Gavelhöjd"
              class="textControll"
              style="color: #333"
            >
              <b-dropdown
                v-model="selectedHeight"
                :mobile-modal="false"
                :disabled="!selectedUprights"
                style="width: 100%"
              >
                <button
                  slot="trigger"
                  class="button"
                  type="button"
                  style="width: 100%; justify-content: space-between"
                >
                  <template v-if="!selectedHeight">
                    <span
                      class="textControll"
                      style="opacity: 0.5"
                    >Välj gavelhöjd...</span>
                  </template>
                  <template v-else>
                    <span class="textControll">{{ selectedHeight }} mm</span>
                  </template>
                  <b-icon
                    type="is-primary"
                    icon="caret-down"
                  />
                </button>

                <b-dropdown-item
                  v-for="(height, index) in availableHeights"
                  :key="index"
                  :value="height"
                >
                  <div class="media">
                    <div class="media-content">
                      <p class="textControll">
                        {{ height }} mm
                      </p>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
            <div
              v-show="sectors.length > 0"
              id="configure-sections"
            >
              <b-field
                label="Sektionsinställningar"
                class="is-mobile bigLabel sectionSetting"
                style="color: #333"
              />
              <div
                class="section-groups-configuration"
              >
                <b-collapse
                  v-for="sector in sectors"
                  :key="sector.index"
                  class="card section-group-card"
                  style="width: calc(300px - 2em)"
                  :open.sync="sector.expanded"
                  :style="{
                    margin: sector.expanded ? '0.5em 0' : '0'
                  }"
                >

                  <div
                    class="card-content"
                  >
                    <div class="content">
                      <p
                        label="Bärbalk"
                        style="color: #333"
                        id="varningPDiv"
                        class="card-header-title"
                      >
                        <b-tooltip
                          multilined
                          v-show="isSectorOverload(sector)"
                          label="Observera att bärbalkarnas lastkapacitet i kombination med antal bärplan överstiger gavlarnas maximala kapacitet."
                          size="is-small"
                          type="is-dark"
                          position="is-top"
                          id="varning-tool-tip"
                        > </b-tooltip>
                          <div class="flexVarningOverLayer">

                            <div class="flexVarning">
                              <b-icon
                                v-show="isSectorOverload(sector)"
                                style="margin-left: 1em; color: darkorange"
                                icon="exclamation-triangle"
                                id="exclamation-triangle"
                                class="pulsate"
                              />
                              <h3
                                id="h3Varning"
                                v-show="isSectorOverload(sector)"
                              >VARNING!</h3>
                              <b-collapse
                                :open="false"
                                aria-id="contentIdForA11y1"
                              >
                                <template #trigger>
                                  <div class="btnVarningWrapper">
                                    <b-button
                                      class=""
                                      id="varningCollapseInfoBtn"
                                      v-show="isSectorOverload(sector)"
                                      label="VARNING!"
                                      type="is-primary"
                                      aria-controls="contentIdForA11y1"
                                    />
                                    <div
                                      v-show="isSectorOverload(sector)"
                                      id="dvgArrowWrapper"
                                    >
                                      <SvgDropDown />
                                    </div>

                                  </div>

                                </template>
                                <div class="notification">
                                  <div class="content">

                                    <p>
                                      Observera att bärbalkarnas lastkapacitet i kombination med antal bärplan överstiger gavlarnas maximala kapacitet.
                                    </p>
                                  </div>
                                </div>

                              </b-collapse>
                            </div>

                          </div>
                         
                      <b-field
                        class="textControll labelParent"
                        label="Bärbalk"
                        style="color: #333"
                      >

                        <b-dropdown
                          v-model="sector.beam"
                          :mobile-modal="false"
                          style="width: 100%"
                          id="select-beam"
                        >
                          <button
                            slot="trigger"
                            class="button"
                            type="button"
                            style="width: 100%; justify-content: space-between"
                          >
                            <template>
                              <span class="textControll">
                                {{ sector.beam.length }} mm
                                {{ sector.beam.pallets }}x{{
                                  sector.beam.loadCapacity
                                }}
                                kg
                              </span>
                            </template>
                            <b-icon
                              type="is-primary"
                              icon="caret-down"
                            />
                          </button>

                          <b-dropdown-item
                            v-for="(beam, index) in availableBeams"
                            :key="index"
                            :value="beam"
                          >
                            <div class="media">
                              <div class="media-content">
                                <p class="textControll">
                                  {{ beam.length }} mm {{ beam.pallets }}x{{
                                    beam.loadCapacity
                                  }}
                                  kg
                                </p>
                              </div>
                            </div>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-field>
                    </div>

                    <b-field
                      class="textControll labelParent"
                      label="Antal bärplan"
                    >
                      <div
                        class="level-count-slider"
                        style="flex-direction: row; display: flex;"
                      >
                        <b-slider
                          v-model="sector.levelCount"
                          size="is-large"
                          :min="1"
                          :max="maxLevels"
                          :step="1"
                          :tooltip="false"
                          style="width: 100%"
                        />
                        <b-input
                          v-model="sector.levelCount"
                          class="textControll"
                          style="width: 4em; margin-left: 1em"
                          numeric
                          readonly
                        />
                      </div>
                    </b-field>

                    <b-field
                      label="Antal sektioner"
                      class="textControll labelParent"
                    >
                      <div
                        class="section-count-slider"
                        style="flex-direction: row; display: flex;"
                      >
                        <b-slider
                          v-model="sector.sectionCount"
                          size="is-large"
                          :min="1"
                          :max="allowedSections"
                          :step="1"
                          :tooltip="false"
                          style="width: 100%"
                        />

                        <b-input
                          v-model="sector.sectionCount"
                          :editable="false"
                          class="textControll"
                          style="width: 4em; margin-left: 1em"
                          numeric
                          readonly
                        />
                      </div>
                    </b-field>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div id="select-options">
              <b-field
                id="select-options-top-label"
                class="textControll"
                label="Tillbehör"
              >
                <!-- id: select-height, tog bort class is-mobile
               @mouseleave="hideInfoModal2('assembledUprightsLabel')"-->
              </b-field>
              <!-- <b-field class="bField">
                <div
                  class="bFieldUnderWrapper"
                  @mouseover="showInfoModal3('assembledUprights')"
                  @mouseleave="hideInfoModal2('assembledUprights')"
                >
                  <div class="bCheckWrapper">
                    <b-checkbox
                      id="assembledUprightsLabel"
                      v-model="assembledUprights"
                      :disabled="!selectedHeight || !selectedBeam"
                      class="textControll width100"
                    >
                      Monterade gavlar
                    </b-checkbox>
                  </div>
                  <button
                    class="svgInfoBtn"
                    @click="toggleMobileInfoModal('assembledUprightsLabel')"
                  >
                    <SvgDropDown />
                  </button>
                </div>
              </b-field>

              <b-field class="bField">
                <b-collapse
                  id="assembledUprightsLabelMobileInfo"
                  aria-id="assembledUprightsLabelMobileInfo"
                  class="panel mobileInfoText"
                  animation="slide"
                  v-show="assembledUprightsLabelMobileInfoIsOpen"
                >
                  <div class="panel-block">
                    <AssembledUprightsInfo></AssembledUprightsInfo>
                  </div>
                </b-collapse>
              </b-field> -->

              <b-field class="bField">
                <div
                  class="bFieldUnderWrapper"
                  @mouseover="showInfoModal3('uprightProtectors')"
                  @mouseleave="hideInfoModal2('uprightProtectors')"
                >
                  <div class="bCheckWrapper">
                    <b-checkbox
                      id="includeUprightProtectorsLabel"
                      v-model="includeUprightProtectors"
                      :disabled="!selectedHeight || !selectedBeam"
                      class="textControll"
                    >
                      Stolpskydd
                    </b-checkbox>
                  </div>
                  <button
                    class="svgInfoBtn"
                    @click="toggleMobileInfoModal('includeUprightProtectorsLabel')"
                  >
                    <SvgDropDown />
                  </button>
                </div>
              </b-field>

              <b-field class="bField">
                <b-collapse
                  id="uprightProtectorsLabelMobileInfo"
                  aria-id="uprightProtectorsLabelMobileInfo"
                  class="panel mobileInfoText"
                  animation="slide"
                  v-show="uprightProtectorsLabelMobileInfoIsOpen"
                >
                  <div class="panel-block">
                    <UprightProtectorsInfo></UprightProtectorsInfo>
                  </div>
                </b-collapse>
              </b-field>

              <b-field class="bField">
                <div
                  class="bFieldUnderWrapper"
                  @mouseover="showInfoModal3('rackGuards')"
                  @mouseleave="hideInfoModal2('rackGuards')"
                >
                  <div class="bCheckWrapper">
                    <b-checkbox
                      id="includeRackGuardsLabel"
                      v-model="includeRackGuards"
                      :disabled="!selectedHeight || !selectedBeam"
                      class="textControll"
                    >
                      Genomskjutningsskydd
                    </b-checkbox>
                  </div>
                  <button
                    class="svgInfoBtn"
                    @click="toggleMobileInfoModal('includeRackGuardsLabel')"
                  >
                    <SvgDropDown />
                  </button>
                </div>
              </b-field>

              <b-field class="bField">
                <b-collapse
                  id="rackGuardsLabelMobileInfo"
                  aria-id="rackGuardsLabelMobileInfo"
                  class="panel mobileInfoText"
                  animation="slide"
                  v-show="rackGuardsLabelMobileInfoIsOpen"
                >

                  <div class="panel-block">
                    <RackGuardsInfo></RackGuardsInfo>
                  </div>
                </b-collapse>
              </b-field>

              <b-field class="bField">
                <div
                  class="bFieldUnderWrapper"
                  @mouseover="showInfoModal3('impactProtectors')"
                  @mouseleave="hideInfoModal2('impactProtectors')"
                >
                  <div class="bCheckWrapper">
                    <b-checkbox
                      id="includeImpactProtectorsLabel"
                      v-model="includeImpactProtectors"
                      :disabled="!selectedHeight || !selectedBeam"
                      class="textControll"
                    >
                      Påkörningsskydd
                    </b-checkbox>
                  </div>
                  <button
                    class="svgInfoBtn"
                    @click="toggleMobileInfoModal('includeImpactProtectorsLabel')"
                  >
                    <SvgDropDown />
                  </button>
                </div>
              </b-field>

              <b-field class="bField">
                <b-collapse
                  id="impactProtectorsLabelMobileInfo"
                  aria-id="impactProtectorsLabelMobileInfo"
                  class="panel mobileInfoText"
                  animation="slide"
                  v-show="impactProtectorsLabelMobileInfoIsOpen"
                >

                  <div class="panel-block">
                    <ImpactProtectorsInfo></ImpactProtectorsInfo>
                  </div>

                </b-collapse>
              </b-field>

              <b-field class="bField">
                <div
                  class="bFieldUnderWrapper"
                  @mouseover="showInfoModal3('doubleRacks')"
                  @mouseleave="hideInfoModal2('doubleRacks')"
                >
                  <div class="bCheckWrapper">
                    <b-checkbox
                      id="doubleRackLabel"
                      v-model="doubleRack"
                      :disabled="!selectedHeight || !selectedBeam"
                      class="textControll"
                    >
                      Dubbelställ
                    </b-checkbox>
                  </div>
                  <button
                    class="svgInfoBtn"
                    @click="toggleMobileInfoModal('includeDoubleRackLabel')"
                  >
                    <SvgDropDown />
                  </button>
                </div>
              </b-field>

              <b-field class="bField">
                <b-collapse
                  id="doubleRackLabelMobileInfo"
                  aria-id="doubleRackLabelMobileInfo"
                  class="panel mobileInfoText"
                  animation="slide"
                  v-show="doubleRackLabelMobileInfoIsOpen"
                >

                  <div class="panel-block">
                    <DoubleRackInfo></DoubleRackInfo>
                  </div>

                </b-collapse>
              </b-field>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="sectors.length > 0"
        id="wrapperMaincontent"
        data-cy="mainview"
        :style="{
          // marginLeft: showDrawer ? '300px' : '0'
        }"
      >
        <!-- Changed min-scale from 0.05 and max from 5-->
        <pinch-zoom
          id="workarea"
          style="width: 100%; height: 100%"
          min-scale="0.5"
          max-scale="4"
        >
          <div
            id="renderarea"
            style="position: relative; cursor: grab"
            :style="{
              // org 120pc left
              //left: '2em',
              width:
                (includeImpactProtectors ? 500 : 0) +
                100 +
                (totalWidth / 1000) * renderSize +
                'px',
              height: 100 + (selectedHeight / 1000) * renderSize + 100 + 'px'
            }"
          >
            <div
              id="1Under"
              :style="{
                fontSize: renderSize + 'px',
                position: 'absolute',
                top: '32px'
              }"
            >
              <div
                id="vyFront"
                :style="{
                  fontSize: '1.5rem',
                  fontFamily: 'Share Tech',
                  position: 'absolute',
                  // changed from - to +100px
                  left: '90px',
                  top: '-' + ((selectedHeight / 1000) * renderSize) / 4 - 1 + 'px'
                }"
              >
                Vy: Front
              </div>

              <div
                id="vyOvan"
                :style="{
                  fontSize: '1.5rem',
                  fontFamily: 'Share Tech',
                  position: 'absolute',
                  left: '90px',
                  top:
                    (selectedHeight / 1000) * renderSize +
                    (doubleRack ? 110 + 120 : 82 + 70) +
                    'px'
                }"
              >
                Vy: Ovan
              </div>

              <div
                v-if="sectors.length"
                data-cy="measurements-height"
                :style="{
                  top: ((selectedHeight / 1000) * renderSize) / 2 - 8 + 'px',
                  left: '-10px',
                  position: 'absolute',
                  fontSize: '1rem',
                  fontFamily: 'Share Tech',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '50px',
                  height: selectedHeight / 1000 + 'px'
                }"
              >
                {{ selectedHeight / 1000 }} m
              </div>

              <div
                v-if="sectors.length"
                data-cy="measurements-height"
                :style="{
                  top:
                    (selectedHeight / 1000) * renderSize +
                    (doubleRack ? 125 : 99) +
                    'px',
                  left: '-10px',
                  position: 'absolute',
                  fontSize: '1rem',
                  fontFamily: 'Share Tech',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '50px',
                  height: selectedHeight / 1000 + 'px'
                }"
              >
                {{ doubleRack ? "2.4" : "1.1" }} m
              </div>
              <svg
                v-if="sectors.length"
                style="position: absolute; top: 0; left: 0"
                width="80px"
                :height="(selectedHeight / 1000) * renderSize + 'px'"
              >
                <defs>
                  <marker
                    id="arrow"
                    markerWidth="18"
                    markerHeight="9"
                    refX="0"
                    refY="5"
                    orient="auto"
                    markerUnits="userSpaceOnUse"
                  >
                    <path
                      d="M0,0 L18,5 L0,9 z"
                      fill="#333"
                      stroke="none"
                    />
                  </marker>
                </defs>
                <line
                  x1="00"
                  y1="0"
                  x2="45"
                  y2="0"
                  stroke="#333"
                  stroke-width="3"
                />
                <line
                  x1="00"
                  :y1="(selectedHeight / 1000) * renderSize"
                  x2="45"
                  :y2="(selectedHeight / 1000) * renderSize"
                  stroke="#333"
                  stroke-width="3"
                />

                <line
                  x1="35"
                  :y1="(selectedHeight / 2000) * renderSize - 20"
                  x2="35"
                  y2="20"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
                <line
                  x1="35"
                  :y1="(selectedHeight / 2000) * renderSize - 20"
                  x2="35"
                  :y2="(selectedHeight / 1000) * renderSize - 20"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
              </svg>

              <svg
                v-if="sectors.length"
                style="position: absolute; left: 0"
                :style="{
                  top: ((selectedHeight + 150) / 1000) * renderSize + 57 + 'px'
                }"
                width="80px"
                height="200px"
              >
                <defs>
                  <marker
                    id="arrow"
                    markerWidth="18"
                    markerHeight="9"
                    refX="0"
                    refY="5"
                    orient="auto"
                    markerUnits="userSpaceOnUse"
                  >
                    <path
                      d="M0,0 L18,5 L0,9 z"
                      fill="#333"
                      stroke="none"
                    />
                  </marker>
                </defs>
                <line
                  x1="00"
                  y1="4"
                  x2="45"
                  y2="4"
                  stroke="#333"
                  stroke-width="2"
                />
                <line
                  x1="00"
                  :y1="mmToEm(doubleRack ? 2475 : 1125)"
                  x2="45"
                  :y2="mmToEm(doubleRack ? 2475 : 1125)"
                  stroke="#333"
                  stroke-width="2"
                />

                <line
                  x1="35"
                  :y1="mmToEm(550)"
                  x2="35"
                  y2="23"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
                <line
                  x1="35"
                  :y1="mmToEm(550)"
                  x2="35"
                  :y2="doubleRack ? '2.155em' : '0.8em'"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
              </svg>
            </div>

            <div
              class="pallet-rack-sectors"
              :style="{
                position: 'relative',
                marginLeft: '50px',
                fontSize: renderSize + 'px'
              }"
            >
              <div
                v-for="sector in sectors"
                :key="sector.id"
                class="pallet-rack-sector-container"
                :style="{
                  position: 'absolute',
                  left: mmToEm(sectorPosition(sector.index))
                }"
              >
                <pallet-rack-sector
                  :sector="sector"
                  :size="renderSize"
                />
              </div>
            </div>

            <!-- Ground -->
            <div
              v-if="sectors.length"
              :style="{
                position: 'absolute',
                left: '34px',
                top: (selectedHeight / 1000) * renderSize + 32 + 'px',
                width:
                  (includeImpactProtectors ? 15 : 0) +
                  (totalWidth / 1000) * renderSize +
                  0.5 * renderSize +
                  'px',
                height: 0.15 * renderSize + 'px',
                background:
                  'repeating-linear-gradient(-45deg, #fff, #fff 3px, #aaa 3px,#aaa 6px)',
                borderTop: '1px solid #aaa'
              }"
            />

            <div :style="{
                fontSize: renderSize + 'px',
                top: 'calc(' + selectedHeight / 1000 + 'em + 3rem)',
                marginLeft: '35px',
                position: 'relative'
              }">
              <div
                v-if="sectors.length"
                data-cy="measurements-width"
                :style="{
                  position: 'absolute',
                  left: '20px',
                  fontSize: '1rem',
                  fontFamily: 'Share Tech',
                  display: 'flex',
                  justifyContent: 'center',
                  width: (totalWidth / 1000) * renderSize + 'px'
                }"
              >
                {{ (totalWidth + (includeImpactProtectors ? 400 : 0) + (includeUprightProtectors ? 200 : 0)) / 1000 }}
                m
              </div>
              <svg
                v-if="sectors.length"
                style="position: absolute; top: -10px; left: 0"
                :width="100 + (totalWidth / 1000) * renderSize + 'px'"
                height="100px"
              >
                <defs>
                  <marker
                    id="arrow"
                    markerWidth="12"
                    markerHeight="10"
                    refX="0"
                    refY="3"
                    orient="auto-start-reverse"
                    markerUnits="strokeWidth"
                  >
                    <path
                      d="M0,0 L0,6 L12,3 z"
                      fill="#333"
                    />
                  </marker>
                </defs>
                <line
                  x1="16"
                  y1="2"
                  :x2="16"
                  y2="39"
                  stroke="#333"
                  stroke-width="1.5"
                />
                <line
                  :x1="
                    14 +
                      ((totalWidth + (includeImpactProtectors ? 350 : 0)) /
                      1000) *
                      renderSize
                  "
                  y1="2"
                  :x2="
                    14 +
                      ((totalWidth + (includeImpactProtectors ? 350 : 0)) /
                      1000) *
                      renderSize
                  "
                  y2="39"
                  stroke="#333"
                  stroke-width="1.5"
                />

                <line
                  :x1="(totalWidth / 2000) * renderSize"
                  y1="30"
                  x2="35"
                  y2="30"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
                <line
                  :x1="(totalWidth / 2000) * renderSize"
                  y1="30"
                  :x2="
                    ((totalWidth + (includeImpactProtectors ? 350 : 0)) /
                      1000) *
                      renderSize -
                      5
                  "
                  y2="30"
                  stroke="#333"
                  stroke-width="1.5"
                  marker-end="url(#arrow)"
                />
              </svg>
              <!-- <pallet-rack-summary></pallet-rack-summary> -->
            </div>
          </div>
        </pinch-zoom>
        <pallet-rack-specification />
        <!-- </b-modal>-->
      </div>
    </div>
    <v-tour
      v-if="showTour"
      id="v-tour"
      name="startTour"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <template v-for="(step, index) of tour.steps">
            <v-step
              v-if="tour.currentStep === index"
              id="v-step"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template v-if="tour.currentStep === 1">
                <div
                  class="btnflex"
                  slot="actions"
                >
                  <button
                    class="v-step__button endGuideBtn"
                    @click="tour.stop"
                  >
                    Avsluta guiden
                  </button>
                  <button
                    class="v-step__button prevGuideBtn"
                    @click="tour.previousStep"
                  >
                    Föregående
                  </button>
                  <button
                    v-show="selectedUprights"
                    class="v-step__button nextGuideBtn"
                    @click="tour.nextStep"
                  >
                    Nästa
                  </button>
                </div>
              </template>
            </v-step>
          </template>
        </transition>
      </template>
    </v-tour>
    <div
      v-if="displayAssembledUprights"
      id="assembledUprightsInfo"
      class="hoverModal"
    >
      <div class="textWrapperHover">
        <AssembledUprightsInfo></AssembledUprightsInfo>
      </div>
      <div class="arrowDiv"></div>
    </div>
    <div
      v-if="displayUprightProtectors"
      id="includeUprightProtectorsInfo"
      class="hoverModal"
    >
      <div class="textWrapperHover">
        <UprightProtectorsInfo></UprightProtectorsInfo>
      </div>
      <div class="arrowDiv"></div>
    </div>
    <div
      v-if="displayRackGuards"
      id="includeRackGuardsLabelInfo"
      class="hoverModal"
    >
      <div class="textWrapperHover">
        <RackGuardsInfo></RackGuardsInfo>
      </div>
      <div class="arrowDiv"></div>
    </div>
    <div
      v-if="displayImpactProtector"
      id="includeImpactProtectorInfo"
      class="hoverModal"
    >
      <div class="textWrapperHover">
        <ImpactProtectorsInfo></ImpactProtectorsInfo>
      </div>
      <div class="arrowDiv"></div>
    </div>
    <div
      v-if="displaydoubleRackInfo"
      id="doubleRackInfo"
      class="hoverModal"
    >
      <div class="textWrapperHover">
        <DoubleRackInfo></DoubleRackInfo>
      </div>
      <div class="arrowDiv"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
// eslint-disable-next-line no-unused-vars
import PinchZoom from "pinch-zoom-element/dist/pinch-zoom.js";
import PalletRackSector from "@/components/PalletRackSector.vue";
import PalletRackSpecification from "@/components/PalletRackSpecification.vue";

import { isMobile } from "buefy/src/utils/helpers";

// Importing text components
import AssembledUprightsInfo from "@/components/infotext/AssembledUprightsInfo.vue";
import UprightProtectorsInfo from "@/components/infotext/UprightProtectorsInfo.vue";
import ImpactProtectorsInfo from "@/components/infotext/ImpactProtectorsInfo.vue";
import RackGuardsInfo from "@/components/infotext/RackGuardsInfo.vue";
import DoubleRackInfo from "@/components/infotext/DoubleRackInfo.vue";
//importing svg
import SvgDropDown from "@/components/infotext/SvgDropDown.vue";
import SvgInfoIcon from "@/components/infotext/SvgInfoIcon.vue";

const TOUR_ACTIVE_CLASS = "tour-active",
  BODY_TOUR = "in-tour";

const logoSvg =
  "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1ODIgMTg5LjIiIHdpZHRoPSIxODAiIGhlaWdodD0iNTkiIGNsYXNzPSJ8Y2lkfGltYWdlIj48cGF0aCBmaWxsPSIjQzczNTMxIiBkPSJNMTQ0LjYgMTg4LjhMMCAxODkuMlYyMmwxNDQuNS0uMXoiLz48cGF0aCBmaWxsPSIjMjMxRjIwIiBkPSJNMTggMzUuOWgzMC43djEzOUgxOHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNNTAuNCAxMDIuNWw0MS43LTY2LjZIMTI1bC00MS40IDY0LjMgNDguNCA3NC43SDk1Ljd6Ii8+PGcgZmlsbD0iI0M3MzUzMSI+PHBhdGggZD0iTTE5NC44IDEzOWwtOS45IDM1LjZoLTMyLjNMMTk0LjggMzZoNDEuMUwyNzkgMTc0LjVoLTMzLjlMMjM0LjQgMTM5aC0zOS42ek0xODEuNiAxNC4yYzAtOCA2LjItMTQuMiAxNC4yLTE0LjIgNy42IDAgMTMuNiA2IDEzLjYgMTQuMiAwIDcuNi01LjggMTQtMTMuOCAxNC03LjggMC0xNC02LjQtMTQtMTR6bTQ4LjMgMTAxLjNsLTguNi0yOS40Yy0yLjUtOC4yLTQuOS0xOC41LTctMjYuN2gtLjRjLTIuMSA4LjItNC4xIDE4LjctNi40IDI2LjdsLTguMiAyOS40aDMwLjZ6bS01LjUtMTAxLjNjMC04IDYtMTQuMiAxNC0xNC4yIDcuOCAwIDEzLjggNiAxMy44IDE0LjIgMCA3LjYtNS44IDE0LTE0IDE0LTguMSAwLTEzLjgtNi40LTEzLjgtMTR6TTI5My41IDM2aDMxLjJ2MTEyLjJoNTEuMXYyNi4zaC04Mi4zVjM2ek0zOTMuNiAzNmgzMS4ydjExMi4yaDUxLjF2MjYuM2gtODIuM1YzNnpNNDkzLjQgMTQyLjJjOC4yIDQuMyAyMS40IDguNiAzNC43IDguNiAxNC40IDAgMjItNiAyMi0xNSAwLTguNi02LjYtMTMuNi0yMy4yLTE5LjMtMjMtOC4yLTM4LjItMjEtMzguMi00MS4xIDAtMjMuNiAxOS45LTQxLjUgNTIuNC00MS41IDE1LjggMCAyNy4xIDMuMSAzNS40IDdsLTcgMjUuMWMtNS4zLTIuNy0xNS40LTYuNi0yOC44LTYuNi0xMy42IDAtMjAuMSA2LjQtMjAuMSAxMy40IDAgOC44IDcuNiAxMi43IDI1LjcgMTkuNSAyNC41IDkgMzUuOCAyMS44IDM1LjggNDEuMyAwIDIzLjItMTcuNyA0My01NS43IDQzLTE1LjggMC0zMS40LTQuMy0zOS4zLTguNmw2LjMtMjUuOHoiLz48L2c+PC9zdmc+";

export default {
  components: {
    PalletRackSector,
    PalletRackSpecification,
    AssembledUprightsInfo,
    UprightProtectorsInfo,
    ImpactProtectorsInfo,
    RackGuardsInfo,
    DoubleRackInfo,
    SvgDropDown,
    SvgInfoIcon,
  },

  data() {
    return {
      displayAssembledUprights: false,
      displayUprightProtectors: false,
      displayRackGuards: false,
      displayImpactProtector: false,
      displaydoubleRackInfo: false,
      showTour: true,
      showDrawer: true,
      // changed to true, /b
      showModal: true,
      renderSize: 60,

      assembledUprightsLabelMobileInfoIsOpen: false,
      uprightProtectorsLabelMobileInfoIsOpen: false,
      rackGuardsLabelMobileInfoIsOpen: false,
      impactProtectorsLabelMobileInfoIsOpen: false,
      doubleRackLabelMobileInfoIsOpen: false,

      tourSteps: [
        {
          target: "#anchor",
          content:
            `<p class="tour-header">Hjälpguide</p><p class="tour-subheader"><img style="margin-top: 9px; margin-left: 9px;" src="data:image/svg+xml;base64,` +
            logoSvg +
            `" /><h2 class="tour-h2">Guide - pallställsbyggare</h2>

          </p><p class="p-tour"><br/>Du kan förstora och förminska vyn av ditt pallställ med mushjulet eller med två fingrar på läsplatta.<br/><br/> Flytta pallstället genom att klicka och hålla ner musens vänsterknapp och
samtidigt dra musen (drag fingret på mobil eller platta)<br/><br/>
Om du vill avsluta guiden och sätta igång själv så går det bra, tryck på knappen "Jag behöver inte hjälp". Tryck på nästa för att starta.<br/><br/>
<strong>Tänk på att pallställsbyggaren bara är ett hjälpmedel, för att få en översyn av ditt pallställ. Eventuella belastningar MÅSTE kontrolleras med KÄLLS.</strong><br/><br/></p>
`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  });

                  return data;
                },
              },
            },
          },
        },
        {
          target: "#select-upright",
          content: `<p class="tour-header">Då sätter vi igång!</p>Börja med att välja den bärkapacitet du behöver för dina gavlar. Du kan när som helst välja en ny gavel som passar dina behov bättre.<br/><br/>Guiden fortsätter automatiskt när du gjort ditt val.`,
          params: {
            placement: "right",
            modifiers: {
              preventOverflow: {
                enabled: true,
                boundariesElement: document.querySelector("#container"),
              },
              offset: { enabled: true, offset: "16 8" },
            },
            enableScrolling: false,
          },
        },
        {
          target: "#select-height",
          content: `<p class="tour-header">Grattis!</b><p class="tour-subheader">Du har nu byggt ett pallställ!</p></b><br/>Pallstället motsvarar kanske inte just dina behov ännu, men det ska vi snart ändra på.</br></br>Vi fortsätter genom att välja gavelhöjd. Om rätt gavelhöjd redan är vald, tryck på Nästa för att fortsätta.`,
          params: {
            placement: "right",
            modifiers: {
              preventOverflow: { enabled: false },
              offset: { enabled: true, offset: "16 8" },
            },
            enableScrolling: false,
          },
        },
        {
          target: "#configure-sections",
          content: `<p class="tour-header">Snart så börjar det likna något!</p><br/>Här kan du ställa in hur många pallplatser du får genom att välja bärbalk, antal bärplan och sektioner.<br/><br/><i>Ifall dina val skulle resultera i risk för gavelöverbelastning indikerar vi detta med en liten varningstriangel.</i><br/><br/>Tryck på nästa för att fortsätta.`,
          params: {
            placement: "right",
            modifiers: {
              preventOverflow: { enabled: false },
              offset: { enabled: true, offset: "0 8" },
              // offset: { enabled: true, offset: '16 40'}
            },
          },
        },
        {
          target: "#select-options",
          content: `<p class="tour-header">Imponerande!</p><p class="tour-subheader">Du är ju bra på detta!</p><br/>Här kan du välja till tillbehör som påkörningsskydd, om du vill ha dubbelställ med mera.<br/><br/>Tryck på nästa för att fortsätta.`,
          params: {
            placement: "right",
            modifiers: {
              preventOverflow: { enabled: false },
              offset: { enabled: true, offset: "0 8" },
              // offset: { enabled: true, offset: '16 40'}
            },
          },
        },
        {
          target: "#anchor",
          content: `<p class="tour-header">Färdiga!</b><p class="tour-subheader">Det var inte så svårt, eller hur?</p><br/>Du har nu kommit till slutet av denna guide, men innan vi släpper dig helt så har vi några tips till:<br/><br/>Vet du att du kan förstora och förminska vyn av ditt pallställ med mushjulet (pinch på mobil och platta)? Du kan även flytta vyn genom att klicka och hålla ner musens vänsterknapp och samtidigt dra musen (drag fingret på mobil eller platta).`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  });

                  return data;
                },
              },
            },
          },
        },
      ],
      tourOptions: {
        labels: {
          buttonSkip: "Avsluta guiden",
          buttonPrevious: "Föregående",
          buttonNext: "Nästa",
          buttonStop: "Avsluta",
        },
      },
      tourCallbacks: {
        onStart: this.onStartTour,
        onNextStep: this.onNextStep,
        onPreviousStep: this.onPreviousStep,
        onStop: this.onStop,
      },
    };
  },

  computed: {
    assembledGablesToolTipTopY: {
      get() {
        let includeUprightProtectorsInfo = document.getElementById(
          "includeUprightProtectorsInfo"
        );
        return 450 - includeUprightProtectorsInfo.offsetHeight;
      },
    },
    selectedUprights: {
      get() {
        return this.$store.state.selectedUprights;
      },
      set(value) {
        this.$store.commit("updateSelectedUprights", value);
      },
    },
    selectedHeight: {
      get() {
        return this.$store.state.selectedHeight;
      },
      set(value) {
        this.$store.dispatch("setHeight", value);
      },
    },
    assembledUprights: {
      get() {
        return this.$store.state.assembledUprights;
      },
      set(value) {
        this.$store.commit("updateAssembledUprights", value);
      },
    },
    includeUprightProtectors: {
      get() {
        return this.$store.state.includeUprightProtectors;
      },
      set(value) {
        this.$store.commit("updateIncludeUprightProtectors", value);
      },
    },
    includeRackGuards: {
      get() {
        return this.$store.state.includeRackGuards;
      },
      set(value) {
        this.$store.commit("updateIncludeRackGuards", value);
      },
    },
    includeImpactProtectors: {
      get() {
        return this.$store.state.includeImpactProtectors;
      },
      set(value) {
        this.$store.commit("updateIncludeImpactProtectors", value);
      },
    },
    selectedBeam: {
      get() {
        return this.$store.state.selectedBeam;
      },
      set(value) {
        this.$store.commit("updateSelectedBeam", value);
      },
    },
    doubleRack: {
      get() {
        return this.$store.state.doubleRack;
      },
      set(value) {
        this.$store.commit("updateDoubleRack", value);
      },
    },
    ...mapState(["sectors", "levels"]),
    ...mapGetters([
      "availableHeights",
      "availableUprights",
      "availableBeams",
      "maxLevels",
      "totalPallets",
      "totalWidth",
      "sectorPosition",
      "allowedSections",
    ]),
  },

  watch: {
    selectedUprights(newUpright, oldUpright) {
      if (!oldUpright) {
        this.selectedHeight = this.availableHeights.find(
          (h) => parseInt(h) > 2500
        );
        this.addSector();
        this.$tours["startTour"].nextStep();

        this.$nextTick(() => {
          const pinchZoom = document.querySelector("#workarea");
          const renderArea = document.querySelector("#renderarea");
          pinchZoom.setTransform({
            //Set the transform. All values are optional
            scale: 1,
            x: 100,
            y: 70,
          });

          let scale = 1;
          if (pinchZoom.clientWidth < pinchZoom.clientHeight) {
            scale = (pinchZoom.clientWidth - 800) / renderArea.offsetWidth;
          } else {
            scale = pinchZoom.clientHeight / renderArea.offsetHeight;
          }
          // sets inital scale, org -1
          pinchZoom.scaleTo(scale - 0.5, {
            // Fire a 'change' event if values are different to current values
            allowChangeEvent: true,
          });

          //eslint-disable-next-line no-unused-vars
          pinchZoom.addEventListener("change", function (event) {
            var x = parseInt(pinchZoom.x);
            var y = parseInt(pinchZoom.y);

            // Using getBoundingClientRect since it's more accurate than using client/offset width or height
            var renderAreaRect = renderArea.getBoundingClientRect();

            var renderWidth = renderAreaRect.width;
            var renderHeight = renderAreaRect.height;

            var newX = x;
            var newY = y;

            let screenMargin = 75;

            // Correcting coordinates if structure is moved outside off the screen horizontally
            if (x < screenMargin) {
              // Too far to the left
              newX = screenMargin;
              console.log(
                "pinchZoom.x too far to the left, now corrected to " + newX
              );
            } else if (x + renderWidth > pinchZoom.clientWidth) {
              // Too far to the right
              // NOTE Correcting this might turn out weird if the renderWidth is greater than the clientWidth.
              // Therefore we will only correct this if the renderWidth is smaller than the pinchzoom width or screen

              if (pinchZoom.clientWidth > renderWidth) {
                console.log(
                  "pinchZoom.x too far to the right, now corrected to " + newX
                );
                newX = pinchZoom.clientWidth - renderWidth;
              } else {
                console.log(
                  "The renderWidth is greater than the clientWidth, not correcting eventhough pinchZoom.x is too far to the right."
                );
              }
            }

            // Correcting coordinates if structure is moved outside off the screen vertically
            if (y < screenMargin) {
              // Too far up
              newY = screenMargin;
              console.log("pinchZoom.y now corrected to " + newY);
            } else if (
              renderHeight + screenMargin < pinchZoom.clientHeight &&
              y + renderHeight + screenMargin > pinchZoom.clientHeight
            ) {
              // Too far down
              // We only correct this if the render height is greater than the client height
              if (renderHeight + screenMargin < pinchZoom.clientHeight) {
                newY = pinchZoom.clientHeight - renderHeight - screenMargin;
                console.log("pinchZoom.y now corrected to " + newY);
              } else {
                // NOTE The configurator is too high, not correcting
                console.log(
                  "NOTE the renderHeight is too high, not correcting eventhough pinchZoom.y is too far up"
                );
              }
            }

            if (newX != pinchZoom.x || newY != pinchZoom.y) {
              pinchZoom.setTransform({
                scale: pinchZoom.scale, // We don't want to change this value
                x: newX,
                y: newY,
              });
            }
          });

          console.log("Alright, should have listeners now :)");
        });
      }

      this.$nextTick(() => {
        if (
          this.availableHeights.findIndex(
            (h) => parseInt(h) === this.selectedHeight
          ) < 0
        ) {
          this.selectedHeight = this.availableHeights.find(
            (h) => parseInt(h) > 2500
          );
        }
      });
    },
    selectedHeight(newHeight, oldHeight) {
      if (oldHeight) this.$tours["startTour"].nextStep();
    },
    availableBeams() {
      this.selectedBeam = this.availableBeams.find((b) => b.default);
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.setShowTour();
  },

  mounted() {
    this.$store.dispatch("requestData").then(() => {
      if (location.href.indexOf("#") == -1) {
        this.$tours["startTour"].start();
      }
    });
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    showInfoModal3(element) {
      // We won't show the tooltip popup if this isn't the mobile mode
      if (isMobile.any()) {
        console.log(
          "showInfoModal3() not showing the info modal since this is the mobile mode"
        );
        return;
      }

      const topAdjust = 20;
      switch (element) {
        case "assembledUprights":
          this.displayAssembledUprights = true;
          this.$nextTick(() => {
            let clientRect = assembledUprightsLabel.getBoundingClientRect();
            let theTop =
              Math.round(clientRect.top) -
              topAdjust -
              assembledUprightsInfo.offsetHeight;
            assembledUprightsInfo.style.top = theTop + "px";
          });
          break;
        case "uprightProtectors":
          let clientRect2 =
            includeUprightProtectorsLabel.getBoundingClientRect();
          this.displayUprightProtectors = true;
          this.$nextTick(() => {
            let theTop =
              Math.round(clientRect2.top) -
              topAdjust -
              includeUprightProtectorsInfo.offsetHeight;
            includeUprightProtectorsInfo.style.top = theTop + "px";
          });
          break;
        case "rackGuards":
          this.displayRackGuards = true;
          let clientRect3 = includeRackGuardsLabel.getBoundingClientRect();
          this.$nextTick(() => {
            let theTop =
              Math.round(clientRect3.top) -
              topAdjust -
              includeRackGuardsLabelInfo.offsetHeight;
            includeRackGuardsLabelInfo.style.top = theTop + "px";
          });
          break;
        case "impactProtectors":
          this.displayImpactProtector = true;
          let clientRect4 =
            includeImpactProtectorsLabel.getBoundingClientRect();
          this.$nextTick(() => {
            let theTop =
              Math.round(clientRect4.top) -
              topAdjust -
              includeImpactProtectorInfo.offsetHeight;
            includeImpactProtectorInfo.style.top = theTop + "px";
          });
          break;
        case "doubleRacks":
          this.displaydoubleRackInfo = true;
          let clientRect5 = doubleRackLabel.getBoundingClientRect();
          this.$nextTick(() => {
            let theTop =
              Math.round(clientRect5.top) -
              topAdjust -
              doubleRackInfo.offsetHeight;
            console.log("dubbelrack" + doubleRackInfo.offsetHeight);
            doubleRackInfo.style.top = theTop + "px";
          });
          break;
      }
    },

    toggleMobileInfoModal(element) {
      var isMobileMode = isMobile.any();

      if (!isMobileMode) {
        console.log(
          "This is not mobile mode, not showing info under the checkbox."
        );
        return;
      }

      switch (element) {
        case "assembledUprightsLabel":
          this.assembledUprightsLabelMobileInfoIsOpen =
            !this.assembledUprightsLabelMobileInfoIsOpen;
          break;
        case "includeUprightProtectorsLabel":
          this.uprightProtectorsLabelMobileInfoIsOpen =
            !this.uprightProtectorsLabelMobileInfoIsOpen;
          break;
        case "includeRackGuardsLabel":
          this.rackGuardsLabelMobileInfoIsOpen =
            !this.rackGuardsLabelMobileInfoIsOpen;
          break;
        case "includeImpactProtectorsLabel":
          this.impactProtectorsLabelMobileInfoIsOpen =
            !this.impactProtectorsLabelMobileInfoIsOpen;
          console.log(
            "Now inverted impactProtectorsLabelMobileInfoIsOpen to: " +
              this.impactProtectorsLabelMobileInfoIsOpen
          );
          break;
        case "includeDoubleRackLabel":
          this.doubleRackLabelMobileInfoIsOpen =
            !this.doubleRackLabelMobileInfoIsOpen;
          console.log("Now inverted doubleRackLabelMobileInfo to:");
          break;
      }
    },

    hideInfoModal2(element) {
      switch (element) {
        case "assembledUprights":
          this.displayAssembledUprights = false;
          break;
        case "uprightProtectors":
          this.displayUprightProtectors = false;
          break;
        case "rackGuards":
          this.displayRackGuards = false;
          break;
        case "impactProtectors":
          this.displayImpactProtector = false;
          break;
        case "doubleRacks":
          this.displaydoubleRackInfo = false;
          break;
      }
    },

    testOnLoad() {
      let theTop = 450 - includeUprightProtectorsInfo.offsetHeight;
      includeUprightProtectorsInfo.style.top = theTop + "px";
    },

    setShowTour() {
      if (document.documentElement.clientWidth < 599) {
        this.showTour = false;
      }
    },

    handleResize() {
      if (!this.showDrawer) {
        this.showDrawer = document.documentElement.clientWidth > 768;
      }
    },

    addSection() {
      this.$store.commit("addSection");

      if (this.levels.length === 0) {
        this.$store.dispatch(
          "setLevelCount",
          Math.ceil(this.selectedHeight / 1000)
        );
      }
    },

    addSector() {
      this.$store.dispatch("addSector");
    },

    removeSector(index) {
      this.$store.dispatch("removeSector", index);
    },

    mmToEm(mm) {
      return mm / 1000 + "em";
    },

    isSectorOverload(sector) {
      let sectorOverload =
        this.selectedUprights.maxLoad /
          (sector.levelCount * sector.beam.pallets) <
        sector.beam.loadCapacity;

      this.$store.state.sectorOverload = sectorOverload;

      return sectorOverload;
    },

    purchase() {
      this.$tours["startTour"].stop();
      this.showModal = true;
      if (document.documentElement.clientWidth <= 768) {
        this.showDrawer = false;
      }
    },

    onStartTour() {
      const curStepEl = document.querySelector(this.tourSteps[0].target);

      //Add the in-tour class to body
      document.body.classList.add(BODY_TOUR);
      //Add the active class for the first step
      curStepEl.classList.add(TOUR_ACTIVE_CLASS);
    },
    onNextStep(step) {
      const curStepEl = document.querySelector(this.tourSteps[step].target);
      const nextStepEl = document.querySelector(
        this.tourSteps[step + 1].target
      );

      //Add active class to next step and remove from current.
      curStepEl.classList.remove(TOUR_ACTIVE_CLASS);
      nextStepEl.classList.add(TOUR_ACTIVE_CLASS);
    },
    onPreviousStep(step) {
      const curStepEl = document.querySelector(this.tourSteps[step].target);
      const prevStepEl = document.querySelector(
        this.tourSteps[step - 1].target
      );

      //Add active step to previous and remove from current.
      curStepEl.classList.remove(TOUR_ACTIVE_CLASS);
      prevStepEl.classList.add(TOUR_ACTIVE_CLASS);
    },
    onStop() {
      //We finished the tour, so remove in-tour from body and remove active class.
      if (document.body.classList.contains(BODY_TOUR))
        document.body.classList.remove(BODY_TOUR);
      if (document.querySelector(`.${TOUR_ACTIVE_CLASS}`))
        document
          .querySelector(`.${TOUR_ACTIVE_CLASS}`)
          .classList.remove(TOUR_ACTIVE_CLASS);
    },
  },
};
</script>

<style>
p.tour-subheader {
  font-weight: 200;
}

.dropdown-menu {
  z-index: 30000;
}

.dropdown-trigger {
  width: 100%;
}

.label {
  width: calc(300px - 3em);
}

body.in-tour {
  pointer-events: none;
}

.v-step {
  z-index: 9999;
}

.tour-active {
  position: relative;
  z-index: 999;
}

@media screen and (min-width: 2000px) {
  .tour-active {
    /* box-shadow: 0 0 0 4px #fff, 0 0 0 4px #ffc107ff, 0 0 0 600px rgba(255, 255, 255, 0.6);
    -webkit-animation: pulse 1s infinite;
    -moz-animation: pulse 1s infinite;
    -o-animation: pulse 1s infinite; */
    animation: pulse 1s infinite;
  }
}

@media screen and (max-width: 2000px) {
  .tour-active {
    /* box-shadow: 0 0 0 4px #fff, 0 0 0 4px #ffc107ff, 0 0 0 600px rgba(255, 255, 255, 0.6); */
    /* -webkit-animation: pulse 1s infinite;
    -moz-animation: pulse 1s infinite;
    -o-animation: pulse 1s infinite; */
    animation: pulse 1s infinite;
  }
}

@media screen and (max-width: 1000px) {
  .tour-active {
    /* box-shadow: 0 0 0 4px #fff, 0 0 0 4px #ffc107ff, 0 0 0 600px rgba(255, 255, 255, 0.6); */
    /* -webkit-animation: pulse 1s infinite;
    -moz-animation: pulse 1s infinite; */
    animation: pulse 1s infinite;
  }
}

.tour-active,
.v-tour {
  pointer-events: auto;
}

@-webkit-keyframes pulse {
  0% {
    box-shadow: 0 0 0 4px #fff, 0 0 0 0 rgba(0, 208, 255, 1),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
  70% {
    box-shadow: 0 0 0 4px #fff, 0 0 0 4px rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 0 4px #fff, 0 0 0 0 rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 8px #fff, 0 0 0 0 rgba(0, 208, 255, 1),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 0 8px #fff, 0 0 0 0 rgba(0, 208, 255, 1),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
  90% {
    -moz-box-shadow: 0 0 0 8px #fff, 0 0 0 20px rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 0 8px #fff, 0 0 0 20px rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
  100% {
    -moz-box-shadow: 0 0 0 8px #fff, 0 0 0 0 rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 0 8px #fff, 0 0 0 0 rgba(0, 208, 255, 0),
      0 0 0 6000px rgba(255, 255, 255, 0.8);
  }
}

.v-step[data-v-aa0cbe42] {
  -webkit-filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  /*background: #d0f3fb;*/
  border-radius: 3px;
  color: #000;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  max-width: 400px;
  padding: 1rem;
  text-align: center;
  line-height: 1.65em;
}
.v-step .v-step__arrow[data-v-aa0cbe42] {
  /*border-color: #d0f3fb;*/
  border-style: solid;
  height: 0;
  margin: 0.5rem;
  position: absolute;
  width: 0;
}
.v-step .v-step__arrow--dark[data-v-aa0cbe42] {
  border-color: #d0f3fb;
}
.v-step[x-placement^="top"][data-v-aa0cbe42] {
  margin-bottom: 0.5rem;
}
.v-step[x-placement^="top"] .v-step__arrow[data-v-aa0cbe42] {
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-width: 0.5rem 0.5rem 0;
  bottom: -0.5rem;
  left: calc(50% - 1rem);
  margin-bottom: 0;
  margin-top: 0;
}
.v-step[x-placement^="bottom"][data-v-aa0cbe42] {
  margin-top: 0.5rem;
}
.v-step[x-placement^="bottom"] .v-step__arrow[data-v-aa0cbe42] {
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  border-width: 0 0.5rem 0.5rem;
  left: calc(50% - 1rem);
  margin-bottom: 0;
  margin-top: 0;
  top: -0.5rem;
}
.v-step[x-placement^="right"][data-v-aa0cbe42] {
  margin-left: 0.5rem;
}
.v-step[x-placement^="right"] .v-step__arrow[data-v-aa0cbe42] {
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-top-color: transparent;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  left: -0.5rem;
  margin-left: 0;
  margin-right: 0;
  top: calc(50% - 1rem);
}
.v-step[x-placement^="left"][data-v-aa0cbe42] {
  margin-right: 0.5rem;
}
.v-step[x-placement^="left"] .v-step__arrow[data-v-aa0cbe42] {
  border-bottom-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  margin-left: 0;
  margin-right: 0;
  right: -0.5rem;
  top: calc(50% - 1rem);
}
.v-step__header[data-v-aa0cbe42] {
  background-color: #ffc107;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  margin: -1rem -1rem 0.5rem;
  padding: 0.5rem;
}
.v-step__content[data-v-aa0cbe42] {
  margin: 0 0 1rem;
}
</style>
